module.exports = __webpack_public_path__ + "static/media/1st.ec6a9451.jpg";